import ActionTypeZona from "../ActionTypeZona";

export default class ActualizarZona extends ActionTypeZona {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = true;
        nuevoEstado.flag.procesandoComandoUpdate = true;
        // nuevoEstado.input.domain.forceUpdate = false;
        /* nuevoEstado.flag.sensorDeAccionActualizar = !(estado.flag.sensorDeAccionActualizar); */
        return nuevoEstado;
    }
}
